'use strict';


module.exports = function ( title, callback ) {
    core.notify({
        title: title,
        icon: 'info',
        type: '',
        buttons: [
            {
                value: gettext('Cancel'),
                click: function () {
                    callback();
                }
            },
            {
                value: gettext('Ok'),
                click: function () {
                    callback(true);
                }
            }
        ]
    });
};
